<template>
  <div class="container">
    <div class="visit-page trans">
      <visit-header
        :headerConfig="headerConfig"
        @handleClickIocn="handleClickIocn"
      />

      <div class="main">
        <h2 class="tit">诚邀您参加,欢迎报名</h2>
        <!-- <div class="obj-list"> -->
        <div
          class="obj-list"
          v-for="(item, i) in currentConference.projects"
          :key="i"
        >
          <div class="obj-item shadow">
            <div class="item-top">
              <h3 class="obj-tit">{{ item.name }}</h3>
              <router-link
                :to="{ name: 'visitDetailPage', params: { pv: item } }"
                >更多详情</router-link
              >
            </div>
            <div class="obj-info">
              {{ item.content }}
            </div>
          </div>
        </div>
        <!-- 报名参观改成从报名那和会场一起选了 -->
        <!-- <visit-select v-if="!isProjectVisits" :options="options" :value="value" :disabled="isProjectVisits" @input="handleChange" />
        <el-button v-if="!isProjectVisits" class="handleVisitSubmit" @click="handleVisitSubmit"
          >提交申请</el-button
        >
        <el-button v-else class="disableVisitSubmit" disabled
          >已完成报名</el-button
        >
        

        <h2 class="tit">已报名项目</h2>
        <div class="obj-list" v-for="(item, j) in this.signupedlist" :key="j">
          <div class="obj-item shadow">
            <div class="item-top">
              <h3 class="obj-tit">{{ item.name }}</h3>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  import visitHeader from "@/components/header"
  import visitSelect from "@/components/singleSelect"
  import CurrentUserMixin from "@/mixin/CurrentUser"
  import CurrentConferMixin from "@/mixin/CurrentConference"
  export default {
    name: "visitPage",
    components: {
      visitHeader,
      visitSelect,
    },
    mixins: [CurrentUserMixin, CurrentConferMixin],
    data() {
      return {
        headerConfig: {
          headerIcon: "city ct-xiangyou",
          headerTitle: "报名参观",
        },
        value: "",
        pvList: [],
        signupedlist: [],
      }
    },
    // created(){

    // },
    // mounted(){

    //    this.signupedlist = this.$store.state.user.signup.projectvisits

    // },
    computed: {
      options() {
        var newArr = []
        if (this.currentConference.projects) {
          var newArr = this.currentConference.projects.map(function (
            value,
            index
          ) {
            let newvalue = {}
            newvalue.value = value.id
            newvalue.label = value.name
            return newvalue
          })
          return newArr
        }
      },
      isProjectVisits(){
        // 是否报名了项目参观
        if(this.signupedlist && this.signupedlist.length>0){
            return true
        }else{
            return false
        }
      }
    },
    watch: {
      currentSignup: {
        handler(val) {
          this.signupedlist = val.projectvisits
        },
        deep: true,
      },
    },
    created() {
      if (this.currentSignup) {
        this.signupedlist = [...this.currentSignup.projectvisits]
      }
    },
    methods: {
      handleClickIocn() {
        history.go(-1)
      },
      handleChange(val) {
        // let currentValue = this.options.filter((item, idx) => {
        //     return item.value == val;
        // });
        // this.value = currentValue[0].value;
        this.value = val
      },
      handleVisitSubmit() {
        if (this.currentSignup.phone !== "") {
          if (this.value.length!="") {
            const url =
              process.env.VUE_APP_API_URL + "api/v1/conference/pvsignup"

            const data = {
              signupid: this.currentSignup.id,
              provisitid: this.value,
            }
            return axios.post(url, data).then((result) => {
              this.$message("申请成功！")
              this.getsign().then((res) => {
                if (res) {
                  this.signupedlist = res.projectvisits
                }
              })
              this.value = ""
            })
          } else {
            this.$message("请先选择项目！")
          }
        } else {
          this.$message("请您先注册报名！")
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .main {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;

    .tit {
      padding-left: 8px;
      margin-top: 30px;
      border-left: 4px solid var(--main-color);
      font-size: 16px;
      font-weight: bold;
      color: #424242;
    }

    .obj-list {
      padding-top: 15px;

      .obj-item {
        width: 100%;
        margin-top: 15px;
        padding: 15px;
        box-sizing: border-box;
        background: #fff;
        border-radius: 5px;

        .item-top {
          display: flex;
          justify-content: space-between;

          .obj-tit {
            color: var(--main-color);
            font-size: 16px;
          }

          a {
            color: var(--main-color);
            font-size: 12px;
          }
        }

        .obj-info {
          margin-top: 15px;
          line-height: 25px;
          color: #666;
        }
      }
    }

    .el-select,
    .el-button {
      width: 100%;
      margin-top: 15px;
    }

    .handleVisitSubmit {
      margin: 50px 0 30px;
      background: var(--main-color);
      color: #fff;
    }
    .disableVisitSubmit {
      margin: 50px 0 30px;
      background: #666;
      color: #fff;
    }
  }
</style>
